import { useCallback, useEffect, useMemo, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from '../../components/ui';
import { GetGuestsByEventId, GetGuestsByEventIdForMember, UpdateGuest } from '../../api/api';
import { INVITE_STATUSES } from '../../utils/helpers';

// Shared logic for the Mark-Status board.
export function useStatus(event) {
  const { user, isAdmin, can } = useAuth();
  const toast = useToast();
  const me = user.UserId;

  const canView = can('CanMembers');
  const canEdit = can('CanMembersEdit') || can('CanMembers');
  const mine = (row) => isAdmin || String(row.CreatedBy) === String(me);

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    setLoading(true);
    const loader = isAdmin
      ? GetGuestsByEventId({ EventId: event.EventId })
      : GetGuestsByEventIdForMember({ EventId: event.EventId, UserId: me });
    loader
      .then(d => setRows(Array.isArray(d) ? d : []))
      .catch(() => toast('Failed to load members'))
      .finally(() => setLoading(false));
  }, [event, isAdmin, me, toast]);

  useEffect(() => { refresh(); }, [refresh]);

  const grouped = useMemo(() => {
    const g = Object.fromEntries(INVITE_STATUSES.map(s => [s, []]));
    rows.forEach(r => { const s = INVITE_STATUSES.includes(r.InviteStatus) ? r.InviteStatus : 'Pending'; g[s].push(r); });
    return g;
  }, [rows]);

  const mark = async (row, status) => {
    if (!canEdit || !mine(row) || status === row.InviteStatus) return;
    setRows(rs => rs.map(r => r.GuestId === row.GuestId ? { ...r, InviteStatus: status } : r));
    try {
      await UpdateGuest({ data: { InviteStatus: status, UpdatedBy: me }, where: `GuestId = ${row.GuestId}` });
    } catch { toast('Could not update status'); refresh(); }
  };

  return { isAdmin, canView, canEdit, mine, rows, loading, grouped, mark };
}
